import { Uuid } from '@ftr/contracts/type/shared'

export class SetCurrentCourtroomIdAction {
  static readonly type = '[Courtroom] Set Current Court Room ID'

  constructor(public currentCourtroomId: Uuid | undefined) {}
}
